import type { NextPage } from 'next'
import Logo from 'componentsUnits/logo'
import styles from '../header/Header.module.scss'
import { IoIosArrowBack } from 'react-icons/io'

interface Props {
  text: string
  disableBack?: boolean
}
const HeaderStatic: NextPage<Props> = (props: Props) => {
  const disableBack = props.disableBack

  return (
    <div className={styles.header_wrapper}>
      <div className={styles.header_container}>
        <div className={styles.header_left_section}>
          {!disableBack && (
            <div style={{ fontSize: '2rem' }}><IoIosArrowBack /></div>
          )}
        </div>

        <div className={styles.header_title}>
          <Logo />
        </div>
        <div className={styles.header_right_section}></div>
      </div >
    </div >
  )
}

export default HeaderStatic
